/* global frameworkScreenReaderText */

// DeBounce Function
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

(function( $ ) {

	// Fix for displaying side controls on <select> elements in Android stock browser
	var nua = navigator.userAgent
	var isAndroid = (nua.indexOf('Mozilla/5.0') > -1 && nua.indexOf('Android ') > -1 && nua.indexOf('AppleWebKit') > -1 && nua.indexOf('Chrome') === -1)
	if (isAndroid) {
		$('select.form-control').removeClass('form-control').css('width', '100%')
	}

	// Set icon for quotes.
	/*
	function setQuotesIcon() {
		$( frameworkScreenReaderText.quote ).prependTo( $formatQuote );
	}
	*/


	/*
	 * Test if inline SVGs are supported.
	 * @link https://github.com/Modernizr/Modernizr/
	 */
	function supportsInlineSVG() {
		var div = document.createElement( 'div' );
		div.innerHTML = '<svg/>';
		return 'http://www.w3.org/2000/svg' === ( 'undefined' !== typeof SVGRect && div.firstChild && div.firstChild.namespaceURI );
	}

	/**
	 * Test if an iOS device.
	*/
	function checkiOS() {
		return /iPad|iPhone|iPod/.test(navigator.userAgent) && ! window.MSStream;
	}

	/*
	 * Test if background-attachment: fixed is supported.
	 * @link http://stackoverflow.com/questions/14115080/detect-support-for-background-attachment-fixed
	 */
	function supportsFixedBackground() {
		var el = document.createElement('div'),
			isSupported;

		try {
			if ( ! ( 'backgroundAttachment' in el.style ) || checkiOS() ) {
				return false;
			}
			el.style.backgroundAttachment = 'fixed';
			isSupported = ( 'fixed' === el.style.backgroundAttachment );
			return isSupported;
		}
		catch (e) {
			return false;
		}
	}

	// Fire on document ready.
	$( document ).ready( function() {
		// setQuotesIcon();
		if ( true === supportsInlineSVG() ) {
			document.documentElement.className = document.documentElement.className.replace( /(\s*)no-svg(\s*)/, '$1svg$2' );
		}


		if ( true === supportsFixedBackground() ) {
			document.documentElement.className += ' background-fixed';
		}


		// Check for object-fit support for optimized background images.
		if (typeof CSS !== 'undefined') {
			if (!CSS.supports("object-fit", "cover")) {
				objectfitFallback();
			}
		} else {
			objectfitFallback();
		}

		// This runs if object-fit is not supported or if the CSS object is not supported either (just in case).
		function objectfitFallback() {
			$('.element-bg > img, .wp-block-gallery.is-cropped .blocks-gallery-item img').each(function() {
				var srcURL = $(this).prop('currentSrc');

				if (typeof srcURL === "undefined") {
					srcURL = $(this).prop('src');
				}

				$(this).parent().css({
					'background-image': 'url(' + srcURL + ')'
				});
			});
		}

		// Ideally, we make sure that any fixed backgrounds are set in CSS for easiest results. In case that doesn't happen, this fallback will check for them and sets the active image URL as CSS. Also, it spits a console warning if Jetpack's Lazy Load is enabled.
		$('.element-bg_fixed > img').each(function() {
			var srcURL = $(this).prop('currentSrc');

			if (typeof srcURL === "undefined") {
				srcURL = $(this).prop('src');
			}

			$(this).parent().css({
				'background-image': 'url(' + srcURL + ')'
			});

			if ($(this).hasClass('jetpack-lazy-image')) {
				console.log(srcURL + ": This fixed background has lazy load enabled, and is probably not rendering. Either turn off lazy load for this image, or set it directly with CSS for best results.");
			}
		});

	    // Responsive video resizing. *CURRENTLY NOT FIRING, NEEDS TESTING TO DETERMINE IF STILL NECESSARY
		var $window = $(window),
			$allVideos, newWidth, $el;

		// Look for references to video embeds, as well as extra iframes.
		$allVideos = $("iframe[src*='//player.vimeo.com'], iframe[src*='//www.youtube.com'], iframe[src*='https://www.youtube-nocookie.com'], object, embed, .content-area iframe").not('.wp-custom-header *');

	    if ($allVideos.length) {
	        $allVideos.each(function() {
	            // jQuery .data does not work on object/embed elements
	            $(this).attr('data-aspectRatio', this.height / this.width).removeAttr('height').removeAttr('width');
	        });

	        var videoResize = function() {
	            $allVideos.each(function() {
	                $el = $(this);  // Automatically detects parent element and resizes according to its dimensions.
	                newWidth = $el.parent().width();
	                $el.width(newWidth).height(newWidth * $el.attr('data-aspectRatio'));
	            });
	        }

	        // Run first call to the videos.
	        videoResize();

	        var windowResize = debounce(videoResize, 250);

	        $window.resize(windowResize);
	    }
	});

	// Add header video class after the video is loaded.
	/*
	$( document ).on( 'wp-custom-header-video-loaded', function() {
		$body.addClass( 'has-header-video' );
	});
	*/
})( jQuery );
